import React from "react";
import { Button, Input, Modal, Switch } from "antd"
import TextArea from "antd/lib/input/TextArea"
import "./discounts.css"
import { Checkbox, FormControlLabel, withStyles } from "@material-ui/core";
// import { useAddUpdateDiscountHook } from "../../hooks/discounts";
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import CustomDatePicker from "../common/CollapseTable/customDatePicker";

const GreenCheckbox = withStyles({
   root: {
      '&$checked': {
         color: '#43a047',
      },
   },
})((props) => <Checkbox color="default" {...props} />);

export const AddRemoveSellerDiscountModal = ({
   // getDiscountList = () => { },
   // deleteDiscountEditData = {},
   showAddSellerDiscountModal = false,
   errorMessages = {},
   isEdit = false,
   formData = {},
   // handleSubmit = () => { },
   handleDateChange,
   handleSelectChange,
   handleSwitchChange,
   sellerDiscountData,
   handleSellerDiscountSubmit,
   toggleAddDiscountModal = () => { }
}) => {
   return (
      <Modal
         visible={showAddSellerDiscountModal}
         closable={true}
         title={(isEdit ? "Edit" : "Add") + " Discounts"}
         onCancel={toggleAddDiscountModal}
         footer={[
            <Button
               className={'ml-2'}
               key="back"
               onClick={toggleAddDiscountModal}
            >
               Cancel
            </Button>,
            <Button
               className={'ml-2'}
               key="submit"
               type="primary"
               // loading={isLoading}
               onClick={handleSellerDiscountSubmit}
            >
               Submit
            </Button>
         ]}
      >
         <div>

            <div className='mb-3 flex'>
               <div className='w-100'>
                  <div>Discount</div>
                  <FormControl>
                     <Select
                        className='newchange'
                        labelId="demo-simple-select-placeholder-label-label"
                        id="demo-simple-select-placeholder-label"
                        name="discount_id"
                        placeholder="Select Discount"
                        value={sellerDiscountData.discount_id}
                        onChange={(e) => { handleSelectChange(e) }}
                        style={{
                           border: '1px solid rgb(204, 204, 204)',
                           borderRadius: '4px',
                           padding: '0 10px',
                        }}
                     //   displayEmpty
                     //   classes={{ select: classes.inputRoot }}
                     >
                        <MenuItem value="">
                           <em>Select Discount</em>
                        </MenuItem>
                        {
                           // console.log(discountList,"::discountList")
                           formData.discountList.map((discount) => <MenuItem value={discount.value}>
                                 {discount.label} - {discount.discount}{discount.is_percentage && '%'}
                           </MenuItem>)
                        }
                     </Select>
                  </FormControl>

                  <div className="mt-2">Delivery Options</div>
                  <FormControl>
                     <Select
                        className='newchange'
                        labelId="demo-simple-select-placeholder-label-label"
                        id="demo-simple-select-placeholder-label"
                        name="delivery_option_id"
                        value={sellerDiscountData.delivery_option_id}
                        onChange={(e) => { handleSelectChange(e) }}
                        style={{
                           border: '1px solid rgb(204, 204, 204)',
                           borderRadius: '4px',
                           padding: '0 10px',
                        }}
                     >
                        <MenuItem value="">
                           <em>Select Discount</em>
                        </MenuItem>
                        {
                           // console.log(discountList,"::discountList")
                           formData.deliveryOptions.map((deliveryOption) => <MenuItem value={deliveryOption.value}>{deliveryOption.label}</MenuItem>)
                        }
                     </Select>
                  </FormControl>

               </div>
            </div>

            {/* <div className='w-100 mb-2'>
               <div>Expire at</div>
               <CustomDatePicker
                  onChange={handleDateChange}
                  value={sellerDiscountData.expire_at}
               />
               {errorMessages.title && <span className='error-message'>{errorMessages.title}</span>}
            </div> */}


            {/* <div className="flex mb-6">
               <Switch
                  checked={sellerDiscountData.status}
                  // checked={discountData.status === "true" || discountData.status === true || false}
                  onChange={(isChecked) => handleSwitchChange(isChecked, "status")}
               />
               <div className="mx-2">Status</div>
            </div> */}

         </div>
      </Modal >
   )
}